import { createRouter, createWebHistory } from 'vue-router';
import BasePath from '@/router/module/basePath';
import UserPath from '@/router/module/userPath';
import HistoryPath from '@/router/module/historyPath';
import ProductPath from '@/router/module/productPath';
import OperatePath from '@/router/module/operatePath';
import { notRegisteredRoutePath, sessionInvalidateCheck, tokenCheck } from '@/router/navigationGuard';
import { useCommonStore } from '@/store/modules/common';
import { NAVIGATION_ITEM } from '@/common/constants/ConstCode';
import { useLayoutStore } from '@/store/modules/layout';
import { isEmpty } from '@/common/utils/Util';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  ...BasePath,
  ...UserPath,
  ...HistoryPath,
  ...ProductPath,
  ...OperatePath
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active'
});

router.beforeEach(async (to, from, next) => {
  const commonStore = useCommonStore();
  const layoutStore = useLayoutStore();
  commonStore.checkedReset();

  const clickSideNav = NAVIGATION_ITEM.map((item) => {
    return item.inner.find((inner) => inner.to === to.path);
  }).filter(Boolean); // null 값은 제외
  if (!isEmpty(clickSideNav)) {
    layoutStore.setBeforePath();
  }

  if (!notRegisteredRoutePath(to, from, next) || !tokenCheck(to, from, next) || !sessionInvalidateCheck(to, from, next))
    next('/login');
  else next();
});

export default router;
